/** Redux is a boundary here: this base API cannot import the domain branch slice. */
export function getPromptBridgeRequestHeaders(previousHeaders: Headers, state: unknown): Headers {
  const headers = new Headers(previousHeaders);
  const branch =
    typeof state === 'object' && state !== null && 'branch' in state ? state.branch : undefined;
  const activeBranchId =
    typeof branch === 'object' && branch !== null && 'activeBranchId' in branch
      ? branch.activeBranchId
      : undefined;
  // An entity's explicit branch takes precedence over the user's currently selected branch.
  if (
    !headers.has('X-Branch') &&
    typeof activeBranchId === 'string' &&
    activeBranchId !== '' &&
    activeBranchId !== '-'
  ) {
    headers.set('X-Branch', activeBranchId);
  }
  return headers;
}
